import { render } from "./hashtag_etiqueta_ingles.vue?vue&type=template&id=5f9a6bc4&scoped=true"
import script from "./hashtag_etiqueta_ingles.vue?vue&type=script&lang=js"
export * from "./hashtag_etiqueta_ingles.vue?vue&type=script&lang=js"

import "./hashtag_etiqueta_ingles.vue?vue&type=style&index=0&id=5f9a6bc4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f9a6bc4"]])

export default __exports__